import React, { Component } from "react";
import { Image } from "semantic-ui-react";
import { connect } from "react-redux";
import { makeLoginRequest } from "../../redux/Auth/authActions";
import { AppColumn, AppRow } from "../UI/Layouts";
import AppText from "../UI/Texts/AppTexts";
import { SizedBox } from "../UI/Sizes";
import { AppLinkedText, AppPrimaryButton, CloseCircleButton } from "../UI/CustomButtons";
import { ASSETS } from "../../hooks/useAssets";
import { LANDING_PAGE_PATH, REGISTRATION_PATH, USER_ACCOUNT } from "../../utils/Constants/Paths";
import { launchOpenIDLoginURL } from "../../utils/criiptoFunctions";
import UserActions from "../../utils/Constants/UserActions";
import { logUserAction } from "../../utils/analyticsFunctions";
import AppFooter from "../Footers/AppFooter";
import { GET_LOGO_AUTO_WIDTH_VALUE } from "../../utils/helperFunctions";
import { t } from "i18next";
import CircularLoader from "../UI/LoadingIndicators/CircularLoadingIndicators";
import { useNavigate } from "react-router-dom";
import BankIDIcon from "../UI/BankIDIcon";

class LoginPage extends Component {
  state = {
    idToken: null,
    targetPath: null,
  };

  componentDidMount() {
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    const idToken = urlParams.get("id_token");
    const targetPath = urlParams.get("target_path");

    this.setState({
      idToken: idToken,
      targetPath: targetPath || USER_ACCOUNT,
    });

    if (idToken) {
      this.props.makeLoginRequest(idToken, (user) => {
        logUserAction(UserActions.bank_id_login_success, {
          analyticsPayload: {
            userId: user.userId,
          },
        });
      }, targetPath || USER_ACCOUNT);

      
    }
  }

  render() {
    const { deviceDetails, auth } = this.props;
    const { isMobile } = deviceDetails;
    const bankIDQRButtonTextColor = isMobile
      ? this.props.theme.primaryColor
      : this.props.theme.colors.white;

    const { idToken } = this.state;

    const hasToken = (idToken && idToken.length > 0);

    const isLoading = (hasToken || (hasToken && auth.authLoading));

    const staffiLogoAlt = "Staffi företagslogotyp - plattform för vårdbemanning och jobbförmedling inom sjukvården"


    if (isLoading) {
      return (
        <AppColumn style={{
          height: "100vh",
          padding: this.props.theme.spacing.contentPadding,
        }} mainAxisAlignment={'center'} crossAxisAlignment={'center'}>
          <CircularLoader style={{
            height: '40px',
            width: '40px',
          }} />
          <SizedBox height={this.props.theme.spacing.elementPadding} />
          <AppText.Caption use={'h2'} color={this.props.theme.colors.grey} margins={{
            marginBottom: "0px",
            marginTop: "0px",
          }} center>
            {hasToken ? t('login.auth.waiting') : t('loading')}
          </AppText.Caption>
        </AppColumn>
      )
    }

    return (<AppColumn>
      <div
        style={{
          margin: "0",
          padding: "0",
          top: "0",
          height: "100vh",
          width: "100%",
          marginTop: "0px",
          backgroundColor: this.props.theme.primaryColor,
          transform: "none",
          justifyContent: "center",
          alignItems: "center",
          background: "linear-gradient(120deg, #318686 30%, #6b2727 100%)",
        }}
      >
        <AppColumn
          crossAxisAlignment={"center"}
          mainAxisAlignment={"center"}
          style={{
            height: "100vh",
          }}
        >
          <AppColumn
            style={{
              height: isMobile ? "100%" : "60vh",
              width: isMobile ? "100%" : "40%",
              backgroundColor: this.props.theme.colors.white,
              borderRadius: isMobile ? "0px" : this.props.theme.radius.default,
              padding: this.props.theme.spacing.contentElementPadding,
            }}

          >
            {isMobile && <AppRow>
              <CloseButton />
            </AppRow>}
            <AppColumn mainAxisAlignment={isMobile ? 'start' : 'center'}
              crossAxisAlignment={'center'} style={{
                flex: 1,
              }}>
              {isMobile && <SizedBox height={this.props.theme.spacing.contentPaddingBig} />}
              <Image
                alt={staffiLogoAlt}
                href={LANDING_PAGE_PATH}
                loading='eager'
                height={20}
                width={80}
                src={this.props.theme.logo} style={{
                  height: '20px',
                  width: '80px',
                }} />
              <SizedBox height={this.props.theme.spacing.contentElementPadding} />
              <AppText.HeadingBig className={'text-headline'} fontWeight={600}>
                {t('login.title')}
              </AppText.HeadingBig >
              <SizedBox height={this.props.theme.spacing.elementPaddingSmall} />
              <SizedBox height={this.props.theme.spacing.elementPaddingSmall} />
              <AppText.BodyText use={'h2'} margins={{
                marginBottom: "0px",
                marginTop: "0px",
              }} center>
                {t('login.description')}
              </AppText.BodyText>
              <SizedBox height={this.props.theme.spacing.contentPadding} />

              {isMobile &&
                <AppPrimaryButton size='big'
                  style={{
                    borderRadius: this.props.theme.radius.button,
                    width: '100%',
                    marginBottom: this.props.theme.spacing.elementPadding

                  }} onClick={() => {
                    launchOpenIDLoginURL({ sameDevice: true, targetPath: this.state.targetPath })
                  }}>
                  <AppRow mainAxisAlignment={'center'}>
                    <Image
                      alt="BankID-ikon - digital legitimering och säker inloggning för användare på Staffi"
                      src={ASSETS.bankIdIcon}
                      loading='eager'
                      height={20}
                      width={GET_LOGO_AUTO_WIDTH_VALUE(10)}
                      style={{
                        height: '20px',
                        width: `${GET_LOGO_AUTO_WIDTH_VALUE(10)}px`,
                        color: this.props.theme.colors.white,
                        filter: 'invert(0) brightness(10)'
                      }}
                    />
                    <SizedBox width={this.props.theme.spacing.elementPadding} />
                    {t('login.bankId.button.open')}
                  </AppRow>
                </AppPrimaryButton>}

              <div style={{
                width: '100%',
                justifyContent: 'center',
                display: !isMobile && 'flex',
              }}>
                <AppPrimaryButton
                  userActionKey={UserActions.bankid_login_started}
                  outline={isMobile}
                  size='big'
                  style={{
                    borderRadius: this.props.theme.radius.button,
                    width: isMobile && '100%',
                    height: '50px',
                    marginTop: isMobile && this.props.theme.spacing.elementPaddingSmall,
                  }}
                  onClick={() => {
                    launchOpenIDLoginURL({ sameDevice: false, targetPath: this.state.targetPath })
                  }}>
                  <AppRow mainAxisAlignment={'center'} >
                    <BankIDIcon
                      src={ASSETS.bankIdIcon}
                      color={bankIDQRButtonTextColor}
                      ariaLabel="BankID - Svensk elektronisk legitimation för säker inloggning och identifiering"
                    />
                    <SizedBox width={this.props.theme.spacing.elementPadding} />
                    <span style={{color: bankIDQRButtonTextColor}}>
                      {t('login.bankId.button.qr_code')}
                    </span>
                  </AppRow>
                </AppPrimaryButton>
              </div>





              <SizedBox height={this.props.theme.spacing.contentPadding} />

              <AppRow>
                <AppText.Caption>
                  {`${t('dont_have_account')}`}
                </AppText.Caption>
                <SizedBox width={this.props.theme.spacing.elementPaddingSmall} />
                <AppLinkedText
                  href={REGISTRATION_PATH}
                  color={this.props.theme.primaryColor}
                  underline
                  style={{
                    fontWeight: 600,
                    cursor: 'pointer'
                  }}
                  fontWeight={600}
                  text={t('create_account')}
                />
              </AppRow>
            </AppColumn>
          </AppColumn>
        </AppColumn>
      </div >
      <AppFooter forceShow />
    </AppColumn>)
  }
}


const CloseButton = ({ onClick }) => {
  const navigate = useNavigate();

  return (<CloseCircleButton onClick={() => {

    navigate(LANDING_PAGE_PATH);

  }} />)
}
export default connect(
  (state) => {
    return {
      auth: state.auth,
      deviceDetails: state.core.deviceDetails,
      theme: state.theme,
    };
  },
  {
    makeLoginRequest,
  }
)(LoginPage);
